import { useAppTheme } from '@shared-ui/theme'
import Svg, { Path } from 'react-native-svg'

type Props = {
  size?: number
  color?: string
}

// Двойной шеврон свайпа: ведущий — полупрозрачный дубль основного.
export function AppIconSwipeArrowRight({ size = 36, color }: Props) {
  const theme = useAppTheme()
  const stroke = color ?? theme.COLOR_ICON_BRAND

  return (
    <Svg width={size} height={size} viewBox="0 0 36 36" fill="none">
      <Path
        opacity={0.5}
        d="M21 24L27 18L21 12"
        stroke={stroke}
        strokeWidth={2.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M10.5 24L16.5 18L10.5 12"
        stroke={stroke}
        strokeWidth={2.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}
